import { useEffect, useState } from "react";
import { getEventDetails } from "../services/guest";
import { isEventExpired } from "../utils/eventUtils";

const useFetchEventDetails = (id) => {
  const [results, setResults] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
        setLoading(true);
        const data = await getEventDetails(id);
        setResults(data);
        // Check if the event is expired
        setIsExpired(isEventExpired(data));
      } catch (error) {
        console.error("error fetching event details", error);
        setError(error.message);
      }
      finally {
        setLoading(false);
      }
    };
    fetchEventDetails();
  }, [id]);
  return { results, loading, error, isExpired };
};
export default useFetchEventDetails;
